import { useQuery } from 'react-query';
import { QueryId, STALE_TIME } from '@/integrations/content/utils';
import formatUrlSearchParameters from '@/libraries/formatters/format-url-search-parameters';
import getCulture from '@/libraries/getters/get-culture';
import getLocale from '@/libraries/getters/get-locale';

type UseQueryGenericProductData = Content.Components['GenericProductModuleDto'];

interface UseQueryGenericProductOptions {
  initialData?: UseQueryGenericProductData;
  parameters: Content.Components['IBookingHeadlessParameters'] & {
    id: string;
    pageId: string;
  };
}

const useQueryGenericProduct = ({
  initialData,
  parameters,
}: UseQueryGenericProductOptions) => {
  const locale = getLocale();

  const query = useQuery<UseQueryGenericProductData>(
    [QueryId.GENERIC_PRODUCT, parameters, locale],
    async () => {
      const baseUrl = '/api/content-modules/generic-product';
      const queryParameters = formatUrlSearchParameters(parameters);

      const fetchResponse = await fetch(
        `${baseUrl}?${queryParameters.toString()}`,
        {
          headers: {
            ['Accept-Language']: getCulture(locale),
            ['Content-Type']: 'application/json',
          },
          method: 'GET',
        },
      )
        .then(response => {
          if (response.ok) return response.json();

          throw new Error(`${response.status} - ${response.statusText}`);
        })
        .catch(error => {
          console.error('hooks.useQueryGenericProduct', error);

          throw error;
        });

      return fetchResponse;
    },
    {
      enabled: !!parameters,
      initialData,
      keepPreviousData: true,
      staleTime: STALE_TIME,
    },
  );

  return query;
};

export default useQueryGenericProduct;
